module.exports = __webpack_public_path__ + "media/images/admin/icons/shield-569925d19f647b2691a02ad86077625b.svg";